export const BACKEND_URL = process.env.REACT_APP_ROOT;
export const BACKEND_STATIC_URL = process.env.REACT_APP_BACKEND_STATIC_URL;
export const REACT_APP_VENDOR_SHOP = process.env.REACT_APP_VENDOR_SHOP;
